import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export function BtnBar({ align = 'right', ...props }) {
    return (_jsx("div", { className: classNames({
            'sg-a-d-f sg-a-fw-w sg-a-g-1': true,
            'sg-a-jc-s': props.stretch,
            'sg-a-fd-rr': align === 'right',
        }), children: props.children }));
}
//# sourceMappingURL=BtnBar.js.map